// Dibuja un PDF dentro de la app (pedido de Rodrigo, 2026-11-01: «pre visualizar la factura en pdf»).
// En el celular un PDF en otra pestaña no sirve: Android lo baja en vez de mostrarlo y la app instalada
// del iPhone no le pasa la sesión al navegador. pdf.js (versión legacy, para teléfonos con navegador
// antiguo) se carga solo la primera vez que se abre un documento.

/** Cada página como un <canvas> dentro de `destino`, al ancho del contenedor. */
export async function dibujarPdf(
  pdf: Blob,
  destino: HTMLElement,
  cancelado: () => boolean,
): Promise<number> {
  const [pdfjs, trabajador] = await Promise.all([
    import('pdfjs-dist/legacy/build/pdf.mjs'),
    import('pdfjs-dist/legacy/build/pdf.worker.min.mjs?url'),
  ]);
  pdfjs.GlobalWorkerOptions.workerSrc = trabajador.default;
  // Sin eval: la política de seguridad del ERP (Caddyfile) no lo permite.
  const doc = await pdfjs.getDocument({
    data: new Uint8Array(await pdf.arrayBuffer()),
    isEvalSupported: false,
  }).promise;
  try {
    // Nítido al ampliar al doble, sin pasarse de memoria en un teléfono barato.
    const densidad = Math.min(window.devicePixelRatio || 1, 2) * 2;
    const ancho = Math.min(Math.max(destino.clientWidth * densidad, 800), 1800);
    for (let i = 1; i <= doc.numPages; i++) {
      if (cancelado()) break;
      const pagina = await doc.getPage(i);
      const viewport = pagina.getViewport({
        scale: ancho / pagina.getViewport({ scale: 1 }).width,
      });
      const canvas = document.createElement('canvas');
      canvas.width = Math.floor(viewport.width);
      canvas.height = Math.floor(viewport.height);
      canvas.setAttribute('aria-label', `Página ${i} de ${doc.numPages}`);
      canvas.setAttribute('role', 'img');
      await pagina.render({ canvas, viewport }).promise;
      if (cancelado()) break;
      destino.appendChild(canvas);
    }
    return doc.numPages;
  } finally {
    void doc.destroy();
  }
}
